import { serviceApi } from '../service';

import { appointmentTypeApi } from '../appointment-types';

export const PER_PAGE = 100;
export const bookingUrl = 'bookings';

const bookAppointment = (storeId, appointmentTypeId, token) =>
  appointmentTypeApi.fetchJSON(appointmentTypeId, bookingUrl, {
    method: 'POST',
    body: { storeId, token },
  });

const getBooking = (bookingId) =>
  serviceApi.fetchJSON(`${bookingUrl}/${bookingId}`, { method: 'GET' });

const cancelBooking = (bookingId) =>
  serviceApi.fetch(`${bookingUrl}/${bookingId}`, { method: 'DELETE' });

const getBookings = (page) =>
  serviceApi.fetchJSON(`${bookingUrl}?page=${page}&perPage=${PER_PAGE}`, { method: 'GET' });

const updateBooking = (bookingId, body) =>
  serviceApi.fetch(`${bookingUrl}/${bookingId}`, { method: 'PUT', body: { ...body } });

export const bookingsApi = {
  bookAppointment,
  getBooking,
  getBookings,
  updateBooking,
  cancelBooking,
  PER_PAGE,
};
